import React, { useRef } from 'react'
import { useHoverDirty } from 'react-use';
import { Icon } from 'antd';

const CloseHoverContainer: React.FC<{
  onClose: any
  closeStyle?: React.CSSProperties,
  showClose?: boolean
}> = ({
  children,
  onClose,
  closeStyle = {},
  showClose = true
}) => {
  const ref = useRef(null)
  const isHovering = useHoverDirty(ref);

  return (
    <div ref={ref}>
      {children}
      <Icon
        style={{
          opacity: isHovering && showClose ? 1 : 0,
          position: 'absolute',
          top: '10px',
          right: '10px',
          color: 'white',
          fontSize: '20px',
          ...closeStyle,
        }}
        type="close-circle"
        theme="twoTone"
        onClick={onClose}
      />
    </div>
  )
}

export default CloseHoverContainer